import React from 'react';
import noNft from '../../images/noNFT.png'
import { SIZE_CLASSES, BUTTON_BASE } from '../../share/button/Button';

const SHARE_TEXT = "Just minted my Lilverse NFT!";
const OPENSEA_URL = 'https://opensea.io/collection/lilverse';

const Finish = () => {
    // Both CTAs are rendered as real anchors rather than window.open() calls:
    // mobile Safari and some in-app wallet browsers block programmatic popups
    // even from inside a click handler, which is exactly where this screen gets
    // used most. A plain target="_blank" link is never blocked.
    const shareHref =
        'https://twitter.com/intent/tweet?text=' + encodeURIComponent(SHARE_TEXT) +
        '&url=' + encodeURIComponent(typeof window !== 'undefined' ? window.location.origin : 'https://lilverse.com');

    return (
        <div className="flex flex-col items-center gap-2">
            <img src={noNft} className="w-[220px] sm:w-[280px] h-auto mb-2" alt="Lili" />
            <div className="flex flex-col gap-4 items-center w-full">
                <p className="font-dang text-lg sm:text-xl md:text-[1.7rem] text-white text-center">You're all set! Check your wallet <br /> for Lilverse NFTs!</p>

                {/* Primary action: seeing the NFT they just paid for is the
                    strongest next step, so it leads. Sharing follows. */}
                <a
                    href={OPENSEA_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`bg-[#FD62A6] text-white no-underline drop-shadow ${BUTTON_BASE} ${SIZE_CLASSES.cta}`}
                >
                    VIEW ON OPENSEA
                </a>

                <p className="font-dang text-lg sm:text-xl md:text-[1.7rem] text-white text-center">Show X your new digital identity!</p>

                {/* Secondary: outlined rather than filled so the two CTAs read as
                    a clear hierarchy instead of competing pink slabs. */}
                <a
                    href={shareHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`bg-transparent text-white no-underline ${BUTTON_BASE} ${SIZE_CLASSES.cta}`}
                >
                    SHARE ON X
                </a>
            </div>
        </div>
    );
};

export default Finish;
